/* eslint-disable react/require-default-props */
import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { hasCookie, setCookie } from 'services/actions/cookies_actions';
import { Container } from './styles';

interface BannerBiddingSummaryProps {
  show?: boolean;
  onClose?: () => void;
}

const BannerBiddingSummaryModal = ({ show, onClose }: BannerBiddingSummaryProps) => {
  const [internalShow, setInternalShow] = useState(false);

  useEffect(() => {
    if (!hasCookie('BiddingSummaryModal')) {
      setInternalShow(true);
    }
  }, []);

  const handleClose = () => {
    setCookie('BiddingSummaryModal', true);
    setInternalShow(false);
    if (onClose) onClose();
  };

  const shouldShow = internalShow || show;

  return (
    <Modal size="lg" show={shouldShow} onHide={handleClose}>
      <Container>
        <div className="modal-body modal-summary m-3">
          <button aria-label="Close" className="close" onClick={handleClose} type="button">
            <span aria-hidden="true">×</span>
          </button>
          <h3 className="mb-4">
            Acesse as principais informações <br /> do edital com apenas um clique
          </h3>
          <div className="row">
            <div className="col-12 col-md-6 font-scale">
              <p>
                <strong>Resumo do Edital</strong> é a nova inteligência artificial do Conlicitação,
                que destaca as informações mais relevantes do edital de forma objetiva para
                facilitar a sua análise.
              </p>
              <p>
                Você pode usar essa funcionalidade em qualquer licitação que tenha o Edital, como a
                ferramenta <a href="/boletim_web/public/boletins">Boletins</a> ou{' '}
                <a href="/banco_de_dados">Encontrar Licitações</a>.
              </p>
            </div>
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default BannerBiddingSummaryModal;
